// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20TMz","newExpiryDate":"styles_newExpiryDate__1267f","footer":"styles_footer__3a3A8"};